import Toaster from "./Toast";
var toaster = new Toaster();
export { default as Position } from "./Positions";
export default toaster;